interface PaymentIntentRequest {
  amount: number;
  payment_option: string[];
  callback_url: string;
  email: string;
  phone: string;
  first_name: string;
  last_name: string;
  orderId: string;
  userId?: string;
}

interface PaymentIntentResponse {
  success: boolean;
  data: {
    message: string;
    intent: {
      success: boolean;
      message: string;
      data:
        | {
            id: string;
            reference: string;
            orderId: string;
            payer: null;
            payee: null;
            paymentOption: string[];
            redirectUrls: string;
            paymentLinks: Record<string, string>;
            metadata: {
              user_email: string;
              user_phone: string;
              user_first_name: string;
              user_last_name: string;
              amount: number;
              reference: string;
              description?: string;
            };
            amount: number;
            status: string;
            createdAt: string;
            updatedAt: string;
          }
        | string;
    };
  };
}

export async function createPaymentIntent(
  payload: PaymentIntentRequest
): Promise<PaymentIntentResponse> {
  const response = await fetch(
    `${import.meta.env.VITE_BASE_URL}/payments/intent`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }
  );

  if (!response.ok) {
    throw new Error(`Payment intent failed: ${response.statusText}`);
  }

  return response.json();
}
